import { useMutation } from 'react-query';
import { activeDirectory, token } from 'services/LocalStorage/localStorage';
import { network } from 'services/network';

import { login as mutationFn } from 'api/endPoints/login';

export const useMutationLogin = () => {
    return useMutation<QueryResponse, QueryError, QueryParams>((params) =>
        mutationFn(params).then((response) => {
            token.set(response.accessToken);
            network.defaults.headers.common['Authorization'] = `Bearer ${response.accessToken}`;
            activeDirectory.set(
                window['ENV_VARIABLES']
                    ? window['ENV_VARIABLES']['REACT_APP_ACTIVE_DIRECTORY_URL']
                    : activeDirectory.get(),
            );
            return response;
        }),
    );
};

export type QueryParams =
    | {
          password: string;
          username: string;
          mfaCode: string | null;
      }
    | {
          encrypt: string;
          time: number;
      };

export interface QueryResponse {
    accessToken: string;
    email: string;
}
